import { WaterfallSlice } from "./types";

export const initialState: WaterfallSlice = {
	response: undefined,
	sessionTracker: undefined
};
